import Api from '../../../services/Api'

export const headerConfigMap = {
  initialPage: {
    title: "Informações Gerais",
    showBack: false,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  natureProduction: {
    title: "Produção",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  generalCondition: {
    title: "Condições Gerais",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  health: {
    title: "Saúde",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  agritourism: {
    title: "Agroturismo",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  education: {
    title: "Escolaridade",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  social: {
    title: "Aspectos socioeconômicos",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  ambiental: {
    title: "Características Ambientais e Agrotóxicos",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  fabricados: {
    title: "Produtos Fabricados",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  infra: {
    title: "Infraestrutura",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
  obra: {
    title: "Gestão / Mão de Obra",
    showBack: true,
    showFilter: true,
    dropdownOptions: Api.getDistritos(),
    filterTooltip: "Limpar Filtro",
    filterIcon: "filtro-limpo.svg",
    filterHoverIcon: "filtro-limpo_2.svg",
  },
};
